/* global axios */
import ApiClient from './ApiClient';

class BillingAPI extends ApiClient {
  constructor() {
    super('billing', { accountScoped: true });
  }

  summary() {
    return axios.get(`${this.url}/summary`);
  }

  plans() {
    return axios.get(`${this.url}/plans`);
  }

  paymentOrders() {
    return axios.get(`${this.url}/payment_orders`);
  }

  createPaymentOrder(payload) {
    return axios.post(`${this.url}/payment_orders`, payload);
  }

  previewPaymentOrderPromotion(payload) {
    return axios.post(`${this.url}/payment_orders/promotion`, payload);
  }

  paymentOrder(id) {
    return axios.get(`${this.url}/payment_orders/${id}`);
  }

  reportPaymentOrderPaid(id) {
    return axios.post(`${this.url}/payment_orders/${id}/report_paid`);
  }

  creditPackages() {
    return axios.get(`${this.url}/credit_packages`);
  }

  creditOrders() {
    return axios.get(`${this.url}/credit_orders`);
  }

  createCreditOrder(creditPackageId) {
    return axios.post(`${this.url}/credit_orders`, {
      credit_package_id: creditPackageId,
    });
  }

  creditOrder(id) {
    return axios.get(`${this.url}/credit_orders/${id}`);
  }

  reportCreditOrderPaid(id) {
    return axios.post(`${this.url}/credit_orders/${id}/report_paid`);
  }
}

export default new BillingAPI();
